import React, { useEffect, useState } from 'react';
import HeaderNotifications from '../../components/header/HeaderNotifications';
import HeaderAccountMenu from '../../components/header/HeaderAccountMenu';
import { fetchCurrentUser } from '../../api';

const AccountHeader = ({
  trialBannerHeight = 0,
  userNavigation,
  onSignOut,
  isNotificationsDrawerOpen = false,
  onToggleNotificationsDrawer,
  className = ''
}) => {
  const [username, setUsername] = useState('');
  const [lastName, setLastName] = useState('');
  const [workspaceName, setWorkspaceName] = useState('');

  useEffect(() => {
    const fetchUserData = async () => {
      const token = localStorage.getItem('directus_token');
      if (!token) return;

      try {
        const userData = await fetchCurrentUser(['first_name', 'last_name', 'linked_workspace.workspace_name']);
        if (!userData) return;
        setUsername(userData.first_name || '');
        setLastName(userData.last_name || '');
        setWorkspaceName(userData.linked_workspace?.workspace_name || '');
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, []);

  return (
    <header
      id="main-header"
      className={`fixed left-0 right-0 z-40 h-12 bg-neutral-100/90 backdrop-blur-sm border-b border-gray-200 px-4 flex items-center justify-end shrink-0 ${className}`}
      style={{ top: `${trialBannerHeight}px` }}
    >
      <div className="flex items-center gap-3">
        <HeaderNotifications
          isOpen={isNotificationsDrawerOpen}
          onToggle={onToggleNotificationsDrawer}
        />
        <HeaderAccountMenu
          userNavigation={userNavigation}
          username={username}
          lastName={lastName}
          workspaceName={workspaceName}
          onSignOut={onSignOut}
        />
      </div>
    </header>
  );
};

export default AccountHeader;
